import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

export const PrivateRoute: React.FC = () => {
  const { user, loading, isPartner } = useAuth();

  // Use the isPartner flag from AuthContext which is already computed
  // This avoids making an extra API call that causes 401 errors
  const hasPartnerAccess = isPartner || user?.userType === 'partner';

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #63739c 0%, #aeb6bf 100%)',
        }}
      >
        <CircularProgress sx={{ color: 'white' }} size={60} />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // IMPORTANT: Enforce partner-only access
  if (!hasPartnerAccess) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #63739c 0%, #aeb6bf 100%)',
        }}
      >
        <Typography variant="h4" sx={{ color: 'white', mb: 2 }}>
          Access Denied
        </Typography>
        <Typography variant="body1" sx={{ color: 'white', mb: 4 }}>
          You do not have partner access to this portal.
        </Typography>
        <Typography variant="body2" sx={{ color: 'white' }}>
          Please contact your administrator if you believe this is an error.
        </Typography>
      </Box>
    );
  }

  // User is authenticated AND has partner role
  return <Outlet />;
};